export const UPDATED = 'question-game/wallet/UPDATED'
